// ============================================================
// VCS.LiveConvo -- Live-Unterhaltung (Solo-Dolmetscher)
// ============================================================
// Ein Geraet, zwei Menschen face-to-face, abwechselndes Sprechen.
// Das Geraet uebersetzt live in beide Richtungen und liest per TTS vor.
//
// Zwei UI-Bausteine (Lea-Spec):
//   A) "+"-Auswahl-Popover in der Chat-Uebersicht (Neuer Chat / Live-Unterhaltung)
//   B) Live-Unterhaltungs-Dialog (fuenf Zonen, vier Zustaende)
//
// Backend-Anbindung: live-convo-* WS-Nachrichten (additiv neben caption-*).
// Capture ist vom Call ENTKOPPELT: eigener getUserMedia + AudioContext, kein
// roomId/peerLang. TTS-Wiedergabe ueber eigenen Web-Audio-Graph (24 kHz).
// ============================================================
window.VCS = window.VCS || {};

VCS.LiveConvo = class {

    // ── Konstanten ───────────────────────────────────────────

    static PCM_SAMPLE_RATE = 16000;   // Capture-Zielrate (wie Caption-Pfad)
    static TTS_SAMPLE_RATE = 24000;   // Realtime-TTS liefert 24 kHz pcm16
    static PAIR_STORAGE_KEY = 'liveConvoPair';
    static SPEAK_STORAGE_KEY = 'liveConvoSpeak';
    static VIEW_STORAGE_KEY = 'liveConvoViewMode';
    // Ansicht des Ausgabefelds, Reihenfolge = Tipp-Reihenfolge der Pille.
    // normal: nie gedreht. auto: gedreht, wenn in Sprache 2 uebersetzt wird
    // (Gegenueber liest). opposite: immer gedreht.
    static VIEW_MODES = ['normal', 'auto', 'opposite'];
    static OUTPUT_MAX_PX = 40;         // fit-to-box Startgroesse (wie Flutter _FitText)
    static OUTPUT_MIN_PX = 25;         // fit-to-box Mindestgroesse, darunter wird gescrollt
    static LISTEN_AGAIN_MS = 1500;     // ohne Vorlesen: so lange "uebersetzt…" nach dem Satz
    static LISTEN_AGAIN_TAIL_MS = 200; // mit Vorlesen: Nachlauf nach dem letzten Ton

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // Sprachpaar + Richtung
        this._langA = 'de';
        this._langB = 'ru';
        this._activeDir = 'AtoB';      // "AtoB" = langA wird gesprochen
        this._autoMode = false;
        this._viewMode = 'normal';
        // Vorlesen. An heisst: der Server synthetisiert die Uebersetzung und
        // schickt Audio. Aus heisst: nur Text -- spart die Sprachausgabe-Kosten
        // und nimmt zugleich das eigene Lautsprecher-Echo aus dem Weg, das
        // sonst laufend gefiltert werden muss.
        this._speak = true;

        // Session-/Capture-Zustand
        this._running = false;
        this._starting = false;
        this._lastText = '';           // letzter finaler Ausgabetext (bleibt bei Abbruch sichtbar)

        // Capture-Nodes (eigenstaendig, NICHT VCS.state -- kein Konflikt mit Caption)
        this._micStream = null;
        this._capCtx = null;
        this._capSource = null;
        this._capProcessor = null;
        this._capMute = null;

        // TTS-Wiedergabe (eigener Graph, 24 kHz)
        this._ttsCtx = null;
        this._ttsGain = null;
        this._ttsNextStartAt = 0;

        // Ruecksprung "uebersetzt…" -> "hoert zu…". Azure schickt Transkript und
        // Uebersetzung im selben Moment und danach nichts mehr -- ohne diesen
        // Timer bliebe der Status bis zum Sitzungsende auf "uebersetzt…".
        this._listenAgainTimer = null;

        // Popover (Baustein A)
        this._plusMenu = null;

        // View-Cache (Dialog)
        this._view = null;
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        this._view = {
            overlay   : document.getElementById('liveConvoOverlay'),
            panel     : document.querySelector('#liveConvoOverlay .live-convo-panel'),
            close     : document.getElementById('liveConvoClose'),
            pairChip  : document.getElementById('liveConvoPairChip'),
            pairA     : document.getElementById('liveConvoPairA'),
            pairB     : document.getElementById('liveConvoPairB'),
            pairPanel : document.getElementById('liveConvoPairPanel'),
            selectA   : document.getElementById('liveConvoSelectA'),
            selectB   : document.getElementById('liveConvoSelectB'),
            swap      : document.getElementById('liveConvoSwap'),
            dirFrom   : document.getElementById('liveConvoDirFrom'),
            dirTo     : document.getElementById('liveConvoDirTo'),
            status    : document.getElementById('liveConvoStatus'),
            output    : document.getElementById('liveConvoOutput'),
            retry     : document.getElementById('liveConvoRetry'),
            auto      : document.getElementById('liveConvoAuto'),
            flip      : document.getElementById('liveConvoFlip'),
            speak     : document.getElementById('liveConvoSpeak'),
            btnA      : document.getElementById('liveConvoBtnA'),
            btnB      : document.getElementById('liveConvoBtnB'),
            startStop : document.getElementById('liveConvoStartStop'),
        };
        if (!this._view.overlay) {
            console.warn('[live-convo] #liveConvoOverlay fehlt -- Feature deaktiviert');
            return;
        }

        this._loadPair();
        this._loadSpeak();
        this._loadViewMode();
        this._populateSelects();
        this._bindDialog();
    }

    // ============================================================
    //  Baustein A -- "+"-Auswahl-Popover
    // ============================================================

    // Vom "+"-Button (chat-messages.js) aufgerufen. Oeffnet/schliesst das
    // Anchored-Menue mit zwei Optionen.
    togglePlusMenu(anchorBtn) {
        if (this._plusMenu) {
            this._closePlusMenu();
            return;
        }
        if (!anchorBtn) return;

        // Ohne das Recht (users.allow_live_convo, kommt per chat-authed) bliebe
        // hier ein Menue mit einem einzigen Eintrag stehen. Dann lieber gleich
        // der Neuer-Chat-Dialog -- derselbe Weg wie der Fallback in
        // chat-messages.js, wenn dieses Modul gar nicht geladen ist.
        if (!VCS.state.liveConvoAvailable) {
            this._openNewChatModal();
            return;
        }

        const menu = document.createElement('div');
        menu.className = 'chat-plus-menu';
        menu.setAttribute('role', 'menu');

        const mkItem = (icon, labelKey, subKey, onClick) => {
            const item = document.createElement('button');
            item.type = 'button';
            item.className = 'chat-plus-item';
            item.setAttribute('role', 'menuitem');
            const label = t(labelKey);
            const sub = subKey ? t(subKey) : '';
            item.innerHTML =
                '<span class="chat-plus-icon">' + icon + '</span>' +
                '<span class="chat-plus-text">' +
                '<span class="chat-plus-label"></span>' +
                (sub ? '<span class="chat-plus-sub"></span>' : '') +
                '</span>';
            item.querySelector('.chat-plus-label').textContent = label;
            if (sub) item.querySelector('.chat-plus-sub').textContent = sub;
            item.addEventListener('click', () => {
                this._closePlusMenu();
                onClick();
            });
            return item;
        };

        const iconChat = '<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>';
        const iconLive = '<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line></svg>';

        // Dating stand hier mal als dritter Eintrag. Es hat jetzt einen eigenen
        // Tab in der Bottom-Nav, direkt neben den Chats -- und das "+" ist fuer
        // Dinge, die man anlegt (ein Chat, eine Unterhaltung), nicht fuer einen
        // ganzen Bereich.
        menu.appendChild(mkItem(iconChat, 'chatPlusNewChat', 'chatPlusNewChatSub', () => this._openNewChatModal()));
        const liveItem = mkItem(iconLive, 'chatPlusLiveTalk', 'chatPlusLiveTalkSub', () => this.open());
        liveItem.classList.add('chat-plus-item--accent');
        menu.appendChild(liveItem);

        document.body.appendChild(menu);
        // Rechte Kante des Popovers buendig mit rechter Kante des Buttons.
        const r = anchorBtn.getBoundingClientRect();
        menu.style.top = (r.bottom + 6) + 'px';
        const right = Math.max(8, window.innerWidth - r.right);
        menu.style.right = right + 'px';

        anchorBtn.setAttribute('aria-expanded', 'true');
        this._plusMenu = menu;
        this._plusAnchor = anchorBtn;

        // Schliessen bei Aussen-Klick / Esc
        this._plusOutside = (e) => {
            if (menu.contains(e.target) || e.target === anchorBtn || anchorBtn.contains(e.target)) return;
            this._closePlusMenu();
        };
        this._plusKey = (e) => { if (e.key === 'Escape') this._closePlusMenu(); };
        setTimeout(() => {
            document.addEventListener('click', this._plusOutside, true);
            document.addEventListener('keydown', this._plusKey, true);
        }, 0);
    }

    _closePlusMenu() {
        if (!this._plusMenu) return;
        document.removeEventListener('click', this._plusOutside, true);
        document.removeEventListener('keydown', this._plusKey, true);
        this._plusMenu.remove();
        this._plusMenu = null;
        if (this._plusAnchor) this._plusAnchor.setAttribute('aria-expanded', 'false');
        this._plusAnchor = null;
    }

    // Oeffnet den heutigen Neuer-Chat-Modal-Pfad UNVERAENDERT.
    _openNewChatModal() {
        const modalEl = document.getElementById('newChatModal');
        if (modalEl && window.bootstrap?.Modal) {
            const title = modalEl.querySelector('.modal-title');
            if (title) title.textContent = t('chatNew');
            bootstrap.Modal.getOrCreateInstance(modalEl).show();
        }
    }

    // ============================================================
    //  Baustein B -- Live-Unterhaltungs-Dialog
    // ============================================================

    open() {
        if (!this._view || !this._view.overlay) return;
        this._closePlusMenu();
        this._renderPairLabels();
        this._renderDirection();
        this._setState('idle');
        this._view.output.textContent = t('liveTalkOutputPlaceholder');
        this._view.output.classList.add('is-placeholder');
        this._applyFlip();
        this._view.overlay.classList.remove('hidden');
        // fit-to-box erst NACH dem Einblenden messen (sonst clientHeight=0).
        this._fitOutput();
    }

    // Schliessen: bei laufender Session erst Bestaetigung.
    async requestClose() {
        if (this._running) {
            const ok = await this._confirm(t('liveTalkConfirmEnd'));
            if (!ok) return;
            this._stopSession('close');
        }
        this._closeOverlay();
    }

    _closeOverlay() {
        this._view.overlay.classList.add('hidden');
        this._view.pairPanel.classList.add('hidden');
        this._view.pairChip.classList.remove('is-open');
    }

    _bindDialog() {
        const v = this._view;

        v.close.addEventListener('click', () => void this.requestClose());
        // Backdrop-Klick schliesst BEWUSST NICHT (Lea-Spec 3.7). Kein Handler.

        // Sprachpaar-Chip -> Sub-Panel auf/zu
        v.pairChip.addEventListener('click', () => {
            const open = v.pairPanel.classList.toggle('hidden') === false;
            v.pairChip.classList.toggle('is-open', open);
        });
        v.selectA.addEventListener('change', () => this._onSelectChange());
        v.selectB.addEventListener('change', () => this._onSelectChange());
        v.swap.addEventListener('click', () => this._swapPair());

        // Zwei grosse Sprach-Buttons (Radio-Logik = Richtungswechsel)
        v.btnA.addEventListener('click', () => this._pickDirection('AtoB'));
        v.btnB.addEventListener('click', () => this._pickDirection('BtoA'));

        // Auto / Flip
        v.auto.addEventListener('change', () => {
            // Auto wird beim Start gelesen. Umschalten waehrend laufender Session
            // ist bewusst nicht erlaubt (Default aus, Manuell bleibt verlaesslich).
            if (this._running) {
                v.auto.checked = this._autoMode;
                return;
            }
            this._autoMode = v.auto.checked;
        });
        // Ansicht: jedes Tippen schaltet weiter (normal -> auto -> opposite).
        // Auch waehrend der Sitzung erlaubt.
        v.flip.addEventListener('click', () => {
            const modes = VCS.LiveConvo.VIEW_MODES;
            this._viewMode = modes[(modes.indexOf(this._viewMode) + 1) % modes.length];
            this._saveViewMode();
            this._renderViewMode();
            this._applyFlip();
        });
        // Vorlesen darf -- anders als Auto -- MITTEN in der Sitzung umgeschaltet
        // werden. Genau dafuer ist der Schalter da: wer unterwegs ohne Kopfhoerer
        // sitzt, stellt ihn ab, ohne die Sitzung neu starten zu muessen.
        v.speak.addEventListener('change', () => {
            this._speak = v.speak.checked;
            this._saveSpeak();
            if (this._running) {
                VCS.signaling?.send({
                    type: 'live-convo-speak',
                    id  : VCS.state.myId,
                    on  : this._speak,
                });
            }
            // Beim Abschalten verstummen: was schon eingeplant ist, laeuft sonst
            // noch sekundenlang weiter, obwohl der Nutzer gerade Stille wollte.
            if (!this._speak) this._silenceTts();
            console.info('[live-convo] Vorlesen ' + (this._speak ? 'an' : 'aus'));
        });

        // Start / Stop
        v.startStop.addEventListener('click', () => {
            if (this._running) this._stopSession('user');
            else void this._startSession();
        });

        // Retry (Fehlerzustand)
        v.retry.addEventListener('click', () => void this._startSession());
    }

    // ── Sprachpaar ───────────────────────────────────────────

    _populateSelects() {
        const fill = (sel) => {
            if (!sel || sel.options.length) return;
            for (const code of AVAILABLE_LANGS) {
                const opt = document.createElement('option');
                opt.value = code;
                opt.textContent = LANG_NAMES[code] || code.toUpperCase();
                sel.appendChild(opt);
            }
        };
        fill(this._view.selectA);
        fill(this._view.selectB);
        this._view.selectA.value = this._langA;
        this._view.selectB.value = this._langB;
    }

    _onSelectChange() {
        const a = this._view.selectA.value;
        const b = this._view.selectB.value;
        if (a === b) {
            // Gleiche Sprache verhindern -- Auswahl zurueckdrehen.
            this._view.selectA.value = this._langA;
            this._view.selectB.value = this._langB;
            return;
        }
        this._langA = a;
        this._langB = b;
        this._savePair();
        this._renderPairLabels();
        this._renderDirection();
        // Aenderung startet keine laufende Session neu (Lea-Spec 3.6). Wenn eine
        // Session laeuft, wird sie mit dem neuen Paar erst beim naechsten Start aktiv.
    }

    _swapPair() {
        const a = this._langA;
        this._langA = this._langB;
        this._langB = a;
        this._view.selectA.value = this._langA;
        this._view.selectB.value = this._langB;
        this._savePair();
        this._renderPairLabels();
        this._renderDirection();
    }

    _loadPair() {
        try {
            const raw = localStorage.getItem(VCS.LiveConvo.PAIR_STORAGE_KEY);
            if (raw) {
                const p = JSON.parse(raw);
                if (p && AVAILABLE_LANGS.includes(p.a) && AVAILABLE_LANGS.includes(p.b) && p.a !== p.b) {
                    this._langA = p.a;
                    this._langB = p.b;
                }
            }
        } catch (_) {}
    }

    _savePair() {
        try {
            localStorage.setItem(VCS.LiveConvo.PAIR_STORAGE_KEY,
                JSON.stringify({ a: this._langA, b: this._langB }));
        } catch (_) {}
    }

    // Vorlesen ist standardmaessig an -- nur ein ausdrueckliches "aus" wird
    // gemerkt. Ein leerer Speicher darf nicht als "aus" gelesen werden, sonst
    // waere der Dolmetscher beim ersten Start stumm.
    _loadSpeak() {
        try {
            const raw = localStorage.getItem(VCS.LiveConvo.SPEAK_STORAGE_KEY);
            if (raw !== null) this._speak = raw !== '0';
        } catch (_) {}
        if (this._view.speak) this._view.speak.checked = this._speak;
    }

    _saveSpeak() {
        try {
            localStorage.setItem(VCS.LiveConvo.SPEAK_STORAGE_KEY, this._speak ? '1' : '0');
        } catch (_) {}
    }

    _loadViewMode() {
        try {
            const raw = localStorage.getItem(VCS.LiveConvo.VIEW_STORAGE_KEY);
            if (VCS.LiveConvo.VIEW_MODES.includes(raw)) this._viewMode = raw;
        } catch (_) {}
        this._renderViewMode();
    }

    _saveViewMode() {
        try {
            localStorage.setItem(VCS.LiveConvo.VIEW_STORAGE_KEY, this._viewMode);
        } catch (_) {}
    }

    _renderViewMode() {
        const btn = this._view.flip;
        if (!btn) return;
        const keys = { normal: 'liveTalkViewNormal', auto: 'liveTalkViewAuto', opposite: 'liveTalkFlipToggle' };
        const label = btn.querySelector('span');
        if (label) {
            label.setAttribute('data-i18n', keys[this._viewMode]);
            label.textContent = t(keys[this._viewMode]);
        }
        btn.classList.toggle('is-on', this._viewMode !== 'normal');
    }

    _renderPairLabels() {
        this._view.pairA.textContent = this._langA.toUpperCase();
        this._view.pairB.textContent = this._langB.toUpperCase();
        this._view.btnA.textContent = LANG_NAMES[this._langA] || this._langA.toUpperCase();
        this._view.btnB.textContent = LANG_NAMES[this._langB] || this._langB.toUpperCase();
        this._renderActiveButton();
    }

    // ── Richtung ─────────────────────────────────────────────

    _pickDirection(dir) {
        if (dir === this._activeDir) return;
        this._activeDir = dir;
        this._renderActiveButton();
        this._renderDirection();
        this._applyFlip();
        // Manueller Button = harter Override (auch im Auto-Modus).
        if (this._running) {
            VCS.signaling?.send({ type: 'live-convo-switch', id: VCS.state.myId, activeDir: dir });
        }
    }

    _renderActiveButton() {
        const aActive = (this._activeDir === 'AtoB');
        this._view.btnA.classList.toggle('is-active', aActive);
        this._view.btnB.classList.toggle('is-active', !aActive);
    }

    _renderDirection() {
        const from = (this._activeDir === 'AtoB') ? this._langA : this._langB;
        const to = (this._activeDir === 'AtoB') ? this._langB : this._langA;
        this._view.dirFrom.textContent = LANG_NAMES[from] || from.toUpperCase();
        this._view.dirTo.textContent = LANG_NAMES[to] || to.toUpperCase();
    }

    // Gegenueber-Ansicht: Ausgabefeld um 180 Grad drehen, aber nur wenn gerade
    // in die Sprache des Gegenuebers uebersetzt wird (Nutzer=langA hat gesprochen).
    _applyFlip() {
        const flipNow = this._viewMode === 'opposite' ||
                        (this._viewMode === 'auto' && this._activeDir === 'AtoB');
        this._view.output.classList.toggle('is-flipped', flipNow);
    }

    // ── Session-Steuerung ────────────────────────────────────

    async _startSession() {
        if (this._running || this._starting) return;
        if (!VCS.state.ws || VCS.state.ws.readyState !== WebSocket.OPEN) {
            this._setError(t('liveTalkErrConnection'));
            return;
        }
        this._starting = true;
        this._hideRetry();

        // Mikrofon-Capture starten (entkoppelt vom Call).
        const ok = await this._startCapture();
        if (!ok) {
            this._starting = false;
            this._setError(t('liveTalkErrNoMic'));
            return;
        }

        // TTS-Graph vorbereiten (User-Geste = Start-Klick, iOS-Resume moeglich).
        this._ensureTts();

        this._autoMode = this._view.auto.checked;
        this._speak = this._view.speak.checked;
        VCS.signaling?.send({
            type     : 'live-convo-start',
            id       : VCS.state.myId,
            name     : VCS.state.myName || 'Solo',
            langA    : this._langA,
            langB    : this._langB,
            activeDir: this._activeDir,
            mode     : this._autoMode ? 'auto' : 'manual',
            speak    : this._speak,
        });

        this._running = true;
        this._starting = false;
        this._streaming = true;
        this._setState('listening');
        this._view.startStop.textContent = t('liveTalkStop');
        this._view.startStop.classList.add('is-running');
        this._view.auto.disabled = true;
        console.info('[live-convo] Session gestartet pair=' + this._langA + '/' + this._langB +
                     ' activeDir=' + this._activeDir + ' mode=' + (this._autoMode ? 'auto' : 'manual'));
    }

    _stopSession(reason) {
        if (!this._running && !this._starting) return;
        this._streaming = false;
        this._running = false;
        this._starting = false;
        if (VCS.state.ws && VCS.state.ws.readyState === WebSocket.OPEN) {
            VCS.signaling?.send({ type: 'live-convo-stop', id: VCS.state.myId });
        }
        this._stopCapture();
        this._view.startStop.textContent = t('liveTalkStart');
        this._view.startStop.classList.remove('is-running');
        this._view.auto.disabled = false;
        this._setState('idle');
        console.info('[live-convo] Session gestoppt reason=' + reason);
    }

    // Verbindungsabbruch mitten im Gespraech: Capture stoppen, letzten Text
    // sichtbar lassen, Retry anbieten (signaling.js -> onclose).
    onConnectionLost() {
        if (!this._running && !this._starting) return;
        this._streaming = false;
        this._running = false;
        this._starting = false;
        this._stopCapture();
        this._view.startStop.textContent = t('liveTalkStart');
        this._view.startStop.classList.remove('is-running');
        this._view.auto.disabled = false;
        this._setError(t('liveTalkErrConnection'));
    }

    // ── Capture (entkoppelt: eigener getUserMedia + AudioContext) ────

    async _startCapture() {
        try {
            this._micStream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    channelCount    : 1,
                    echoCancellation: true,   // Pflicht: TTS laeuft parallel am selben Geraet
                    noiseSuppression: true,
                    autoGainControl : true,
                },
                video: false,
            });
        } catch (err) {
            console.warn('[live-convo] Mikrofon-Zugriff fehlgeschlagen:', err && err.message);
            return false;
        }

        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) {
            console.warn('[live-convo] Kein AudioContext verfuegbar');
            this._micStream.getTracks().forEach(tr => tr.stop());
            this._micStream = null;
            return false;
        }

        const trackSettings = this._micStream.getAudioTracks()[0]?.getSettings?.() || {};
        const streamRate = Number(trackSettings.sampleRate);
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const ctxRate = Number.isFinite(streamRate) && streamRate > 0
            ? streamRate
            : (isSafari ? 48000 : undefined);
        this._capCtx = ctxRate ? new AudioCtx({ sampleRate: ctxRate }) : new AudioCtx();
        if (this._capCtx.state === 'suspended') {
            await this._capCtx.resume().catch(() => {});
        }

        this._capSource = this._capCtx.createMediaStreamSource(this._micStream);
        // Gain 1.0 (unity) -- Boost + AGC fuehrt zu Clipping (siehe Caption-Pfad).
        const gain = this._capCtx.createGain();
        gain.gain.value = 1.0;
        this._capSource.connect(gain);

        this._capProcessor = this._capCtx.createScriptProcessor(4096, 1, 1);
        this._capProcessor.onaudioprocess = (event) => {
            if (!this._streaming) return;
            if (!VCS.state.ws || VCS.state.ws.readyState !== WebSocket.OPEN) return;
            if (isSafari && this._capCtx?.state === 'suspended') {
                this._capCtx.resume().catch(() => {});
                return;
            }
            const float32 = event.inputBuffer.getChannelData(0);
            const inputRate = event.inputBuffer.sampleRate || this._capCtx.sampleRate;
            const int16 = this._floatToInt16Mono(float32, inputRate, VCS.LiveConvo.PCM_SAMPLE_RATE);
            if (int16.length === 0) return;
            VCS.signaling?.sendBinary(int16.buffer);
        };

        gain.connect(this._capProcessor);
        // Stummer Gain -> destination: ScriptProcessor braucht verbundenen Output,
        // aber das Mikrofon-Signal darf NICHT ueber die Lautsprecher laufen (Echo).
        this._capMute = this._capCtx.createGain();
        this._capMute.gain.value = 0;
        this._capProcessor.connect(this._capMute);
        this._capMute.connect(this._capCtx.destination);
        return true;
    }

    _stopCapture() {
        if (this._capProcessor) {
            this._capProcessor.onaudioprocess = null;
            try { this._capProcessor.disconnect(); } catch (_) {}
            this._capProcessor = null;
        }
        if (this._capSource) { try { this._capSource.disconnect(); } catch (_) {} this._capSource = null; }
        if (this._capMute) { try { this._capMute.disconnect(); } catch (_) {} this._capMute = null; }
        if (this._capCtx) { this._capCtx.close().catch(() => {}); this._capCtx = null; }
        if (this._micStream) {
            this._micStream.getTracks().forEach(tr => tr.stop());
            this._micStream = null;
        }
    }

    // Float32 -> Int16 Mono mit optionalem Downsampling (Mittelwert pro Ziel-Sample).
    _floatToInt16Mono(input, inputRate, targetRate) {
        if (!input || input.length === 0) return new Int16Array(0);
        const clamp = v => v < 0 ? v * 0x8000 : v * 0x7FFF;
        if (!Number.isFinite(inputRate) || inputRate <= 0 || inputRate <= targetRate) {
            const out = new Int16Array(input.length);
            for (let i = 0; i < input.length; i++) out[i] = clamp(Math.max(-1, Math.min(1, input[i])));
            return out;
        }
        const ratio = inputRate / targetRate;
        const outLen = Math.max(1, Math.floor(input.length / ratio));
        const out = new Int16Array(outLen);
        let off = 0;
        for (let o = 0; o < outLen; o++) {
            const next = Math.round((o + 1) * ratio);
            let acc = 0, cnt = 0;
            for (let i = off; i < next && i < input.length; i++) { acc += input[i]; cnt++; }
            out[o] = clamp(Math.max(-1, Math.min(1, cnt > 0 ? acc / cnt : 0)));
            off = next;
        }
        return out;
    }

    // ── TTS-Wiedergabe (eigener Web-Audio-Graph, 24 kHz) ─────

    _ensureTts() {
        if (this._ttsCtx && this._ttsCtx.state !== 'closed') return this._ttsCtx;
        const Ctor = window.AudioContext || window.webkitAudioContext;
        if (!Ctor) return null;
        let ctx;
        try { ctx = new Ctor({ sampleRate: VCS.LiveConvo.TTS_SAMPLE_RATE }); }
        catch (_) { ctx = new Ctor(); }
        if (ctx.state === 'suspended') ctx.resume().catch(() => {});
        const gain = ctx.createGain();
        gain.gain.value = 1;
        gain.connect(ctx.destination);
        this._ttsCtx = ctx;
        this._ttsGain = gain;
        this._ttsNextStartAt = 0;
        return ctx;
    }

    // Alles Eingeplante sofort verwerfen und den Ausgang kurz stummschalten.
    // Ein reines gain=0 reicht nicht: bereits gestartete Quellen laufen weiter
    // und wuerden beim Wiedereinschalten mitten im alten Satz hoerbar.
    _silenceTts() {
        if (!this._ttsCtx || this._ttsCtx.state === 'closed') return;
        try {
            this._ttsGain.disconnect();
            const gain = this._ttsCtx.createGain();
            gain.gain.value = 1;
            gain.connect(this._ttsCtx.destination);
            this._ttsGain = gain;
        } catch (_) {}
        this._ttsNextStartAt = 0;
    }

    _playChunk(b64, sampleRate) {
        // TTS-Ausfall ist KEIN Fehlerzustand (Text funktioniert allein).
        if (!this._speak) return;   // Nachzuegler nach dem Abschalten schlucken
        const ctx = this._ensureTts();
        if (!ctx) return;
        let pcm;
        try { pcm = this._decodeB64Pcm16(b64); }
        catch (err) { console.warn('[live-convo] TTS-Dekodier-Fehler:', err && err.message); return; }
        if (!pcm.length) return;
        const rate = sampleRate || VCS.LiveConvo.TTS_SAMPLE_RATE;
        const buffer = ctx.createBuffer(1, pcm.length, rate);
        buffer.copyToChannel(pcm, 0, 0);
        const src = ctx.createBufferSource();
        src.buffer = buffer;
        src.connect(this._ttsGain);
        const now = ctx.currentTime;
        let startAt = this._ttsNextStartAt;
        // Nur zuruecksetzen, wenn wir HINTER der Echtzeit liegen (Luecke). NICHT
        // wenn wir voraus sind: bei gestreamtem TTS treffen die Stuecke schneller
        // als Echtzeit ein und muessen lueckenlos VORAUS geplant werden. Ein
        // "zu weit voraus"-Reset wuerde spaetere Stuecke auf now zurueckziehen
        // und ueber die noch laufende Wiedergabe legen -> doppelter/abgehackter Ton.
        //
        // Beim Neustart (Luecke/erste Aeusserung) einen kleinen Vorpuffer geben,
        // statt exakt auf now zu planen: sonst startet die Wiedergabe ohne Polster
        // und unterlaeuft kurz -> Haken am Anfang. ~0.12s kosten kaum Latenz.
        if (startAt < now) startAt = now + 0.12;
        src.start(startAt);
        this._ttsNextStartAt = startAt + buffer.duration;
    }

    _decodeB64Pcm16(b64) {
        const bin = atob(b64);
        const len = bin.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
        const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        const samples = Math.floor(len / 2);
        const out = new Float32Array(samples);
        for (let i = 0; i < samples; i++) out[i] = view.getInt16(i * 2, true) / 32768;
        return out;
    }

    _releaseTts() {
        this._ttsNextStartAt = 0;
        try { this._ttsGain?.disconnect(); } catch (_) {}
        this._ttsGain = null;
        if (this._ttsCtx) { this._ttsCtx.close().catch(() => {}); this._ttsCtx = null; }
    }

    // ============================================================
    //  Backend-Events (aus signaling.js dispatch)
    // ============================================================

    onStarted(msg) {
        console.info('[live-convo] started ack sessions=', JSON.stringify(msg.sessions || {}));
        this._setState('listening');
    }

    onTranscript(msg) {
        // Original des Sprechers -- das dominante Feld bleibt der Uebersetzung
        // vorbehalten. Nur der Status spiegelt, dass gehoert wird.
        if (msg && typeof msg.text === 'string' && msg.text.trim()) {
            this._setState('listening');
        }
    }

    onTranslated(msg) {
        if (!msg || typeof msg.text !== 'string') return;
        // Nur die aktuell aktive Richtung im dominanten Feld anzeigen -- das
        // Ausgabefeld ist immer fuer die Person bestimmt, die NICHT gesprochen hat.
        // Zieltext hell darstellen (translating), auch final.
        this._view.output.textContent = msg.text;
        this._view.output.classList.remove('is-placeholder');
        this._fitOutput();
        this._setState('translating');
        if (!msg.partial) {
            this._lastText = msg.text;
            // Bei Vorlesen verschiebt das erste Audio-Stueck den Ruecksprung ans
            // Ende der Wiedergabe. Kommt keins (TTS-Ausfall), greift diese Frist.
            this._scheduleListenAgain(VCS.LiveConvo.LISTEN_AGAIN_MS);
        }
    }

    onAudioChunk(msg) {
        if (!msg || typeof msg.audio !== 'string' || !msg.audio.length) return;
        this._setState('translating');
        this._playChunk(msg.audio, msg.sampleRate);
        // Zurueck auf "hoert zu…", sobald das zuletzt eingeplante Stueck verklungen ist.
        const ctx = this._ttsCtx;
        const restMs = (ctx && this._ttsNextStartAt > ctx.currentTime)
            ? (this._ttsNextStartAt - ctx.currentTime) * 1000
            : 0;
        this._scheduleListenAgain(restMs + VCS.LiveConvo.LISTEN_AGAIN_TAIL_MS);
    }

    _scheduleListenAgain(ms) {
        clearTimeout(this._listenAgainTimer);
        this._listenAgainTimer = setTimeout(() => {
            this._listenAgainTimer = null;
            if (this._running) this._setState('listening');
        }, ms);
    }

    onSwitched(msg) {
        if (!msg) return;
        // Auto-Switch vom Server: UI nachziehen (manueller Switch hat die UI
        // bereits gesetzt, dann ist activeDir schon korrekt).
        if (msg.activeDir && msg.activeDir !== this._activeDir) {
            this._activeDir = msg.activeDir;
            this._renderActiveButton();
            this._renderDirection();
            this._applyFlip();
        }
    }

    onStopped(msg) {
        const reason = msg && msg.reason;
        if (reason === 'reconnect_failed') {
            this.onConnectionLost();
            return;
        }
        // Sauberes Ende vom Server -- lokalen Zustand angleichen.
        if (this._running || this._starting) {
            this._streaming = false;
            this._running = false;
            this._starting = false;
            this._stopCapture();
            this._view.startStop.textContent = t('liveTalkStart');
            this._view.startStop.classList.remove('is-running');
            this._view.auto.disabled = false;
            this._setState('idle');
        }
    }

    onError(msg) {
        const code = msg && msg.code;
        console.warn('[live-convo] error code=' + code + ' msg=' + (msg && msg.message));
        this._streaming = false;
        this._running = false;
        this._starting = false;
        this._stopCapture();
        this._view.startStop.textContent = t('liveTalkStart');
        this._view.startStop.classList.remove('is-running');
        this._view.auto.disabled = false;
        // Freundliche Meldung; unsupported Sprache klar benennen.
        if (code === 'lang_unsupported') this._setError(t('liveTalkErrNothing'));
        // Fehlendes Recht: kann auftreten, wenn der Admin es entzieht, waehrend
        // der Dialog offen steht. "Verbindung unterbrochen" waere hier schlicht
        // falsch und schickt die Fehlersuche in die falsche Richtung.
        else if (code === 'not_allowed') this._setError(t('liveTalkErrNotAllowed'));
        else this._setError(t('liveTalkErrConnection'));
    }

    // ── Zustaende / UI ───────────────────────────────────────

    _setState(state) {
        // Jeder Statuswechsel verwirft einen offenen Ruecksprung; wer ihn braucht,
        // plant ihn danach neu (onTranslated / onAudioChunk).
        clearTimeout(this._listenAgainTimer);
        this._listenAgainTimer = null;
        const map = {
            idle       : 'liveTalkStateReady',
            listening  : 'liveTalkStateListening',
            translating: 'liveTalkStateTranslating',
        };
        const key = map[state] || 'liveTalkStateReady';
        this._view.status.textContent = t(key);
        this._view.status.classList.remove('is-error');
        // Pille: grau bei Bereit, rot beim Zuhoeren (wie Aufnahme), gruen beim Uebersetzen.
        this._view.status.classList.toggle('is-idle', key === 'liveTalkStateReady');
        this._view.status.classList.toggle('is-listening', state === 'listening');
        this._view.status.classList.toggle('is-translating', state === 'translating');
        // Wie Flutter: der Rahmen des Ausgabefelds leuchtet, solange zugehoert wird.
        this._view.output.parentElement?.classList.toggle('is-listening', state === 'listening');
    }

    _setError(text) {
        clearTimeout(this._listenAgainTimer);
        this._listenAgainTimer = null;
        this._view.status.textContent = text;
        this._view.status.classList.remove('is-idle', 'is-listening', 'is-translating');
        this._view.status.classList.add('is-error');
        // Letzten Text sichtbar lassen (kann das Einzige sein, was lesbar ist).
        if (!this._lastText) {
            this._view.output.textContent = text;
            this._view.output.classList.remove('is-placeholder');
            this._fitOutput();
        }
        this._showRetry();
    }

    _showRetry() { this._view.retry.classList.remove('hidden'); }
    _hideRetry() { this._view.retry.classList.add('hidden'); }

    // fit-to-box: Schrift von OUTPUT_MAX_PX nach unten verkleinern bis der Text
    // ohne Ueberlauf passt (Mindestgroesse OUTPUT_MIN_PX). Kurze Saetze = riesig.
    _fitOutput() {
        const el = this._view.output;
        if (!el) return;
        let size = VCS.LiveConvo.OUTPUT_MAX_PX;
        el.style.fontSize = size + 'px';
        // Grenze ist das Element selbst (max-height : 100 % der Box). Die Wrapper-
        // Hoehe enthielte dessen Padding, der Text liefe dann ueber, ohne kleiner
        // zu werden.
        let guard = 0;
        while (size > VCS.LiveConvo.OUTPUT_MIN_PX &&
               (el.scrollHeight > el.clientHeight + 1 || el.scrollWidth > el.clientWidth + 1) &&
               guard < 40) {
            size -= 1;
            el.style.fontSize = size + 'px';
            guard++;
        }
        // Passt der Text auch bei Mindestgroesse nicht: ans Ende scrollen, damit
        // immer die neuesten Worte sichtbar sind.
        el.scrollTop = el.scrollHeight;
    }

    // ── Kleine Helfer ────────────────────────────────────────

    _confirm(text) {
        if (VCS.ui?.showConfirm) {
            try {
                const r = VCS.ui.showConfirm(text);
                return (r && typeof r.then === 'function') ? r : Promise.resolve(!!r);
            } catch (_) { /* fallthrough */ }
        }
        return Promise.resolve(window.confirm(text));
    }
};

// Singleton, beim Bundle-Init angehaengt (analog VCS.captions etc.).
VCS.liveConvo = new VCS.LiveConvo();
